<template>
  <div>
    <div v-if="dataUrl">
      <div class="d-block bg-light d-flex justify-content-center align-content-center">
        <img :src="previewSignature" alt="" class="img-fluid">
      </div>
      <input type="hidden" :name="name" :value="dataUrl">
    </div>
    <div v-else-if="oldImageUrl">
      <div class="d-block bg-light d-flex justify-content-center align-content-center">
        <img :src="oldImageUrl" alt="" class="img-fluid">
      </div>
    </div>
    <a v-else href class="d-block bg-light d-flex justify-content-center align-content-center"  v-on:click.prevent="showModal">
      <span class="p-5">{{ $t('Add signature') }}</span>
    </a>
    <div v-if="dataUrl || oldImageUrl">
      <button type="button" v-on:click.prevent="deleteSignature" class="mt-3 btn btn-outline-danger btn-sm btn-block">
        {{ $t('Delete signature') }}
      </button>
    </div>
    <Dialog :open="modalIsOpen" @update:open="modalIsOpen = false">
      <DialogScrollContent class="tw:sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            {{ $t('Signature') }}
          </DialogTitle>
        </DialogHeader>

        <LoadingOverlay :active="isUploading">
          <SignaturePad ref="signaturePad" v-on:input="onSignatureUpdate"></SignaturePad>
        </LoadingOverlay>

        <DialogFooter>
          <button type="button" class="btn btn-secondary"
                  v-on:click="resetSignature()">{{ $t('Cancel') }}</button>
          <button type="button" class="btn btn-primary" :disabled="!editedDataUrl || isUploading"
                  v-on:click="setSignatureDataUrl()">{{ $t('Apply') }}</button>
        </DialogFooter>
      </DialogScrollContent>
    </Dialog>
  </div>
</template>

<script setup>
import {ref, defineProps, defineEmits, nextTick, watch} from "vue";
import SignaturePad from '@/components/signature/SignaturePad.vue'
import { Dialog, DialogScrollContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import LoadingOverlay from "@/components/ui/LoadingOverlay.vue";
import { useFileUpload } from '@/composables/useFileUpload';

const props = defineProps({
  name: {
    required: true,
    type: String,
  },
  modelValue: {
    type: String,
    default: null,
  },
})

const oldImageUrl = ref(props.modelValue)
const editedDataUrl = ref(null)
const previewSignature = ref(null)
const dataUrl = ref(null)
const modalIsOpen = ref(false)
const signaturePad = ref(null)

// Utiliser le composable pour l'upload
const { isUploading, uploadProgress, uploadImageDataUrl } = useFileUpload()

watch(() => modalIsOpen.value, (isOpen) => {
  if(isOpen) {
    nextTick(() => {
      signaturePad.value.resetSignature();
    })
  }
})

const onSignatureUpdate = (e) => {
  editedDataUrl.value = e;
}

const showModal = () => {
  modalIsOpen.value = true;
}

const emit = defineEmits([
  'update:modelValue',
]);

const deleteSignature = () => {
  dataUrl.value = null;
  oldImageUrl.value = null;
  modalIsOpen.value = false;
  emit('update:modelValue', null);
}
const resetSignature = () => {
  editedDataUrl.value = null;
  modalIsOpen.value = false;
  emit('update:modelValue', null);
}

const setSignatureDataUrl = async () => {
  if (!editedDataUrl.value) return;

  try {
    // Si c'est un dataURL, l'uploader sur S3
    if (editedDataUrl.value.startsWith('data:')) {
      const result = await uploadImageDataUrl(editedDataUrl.value, {
        filename: 'signature.png',
        visibility: 'private'
      })

      // Utiliser la clé S3
      dataUrl.value = result.key;
      // set previewSignature to the uploaded image URL
      previewSignature.value = result.dataUrl;
    } else {
      // Si c'est déjà une clé S3, l'utiliser directement
      dataUrl.value = editedDataUrl.value;
    }

    modalIsOpen.value = false;
    emit('update:modelValue', dataUrl.value);

  } catch (error) {
    console.error('Erreur lors de l\'upload de la signature:', error);
  }
}
</script>
